import { useMutation } from "@tanstack/react-query";
import api from "../utils/api";
const fetchUpdateAssignmentToPass = (assignmentList) => {
  return api.post(`/admin/assignment/pass`, { assignmentList: assignmentList });
};

export const useUpdateAssignmentToPassQuery = () => {
  return useMutation({ mutationFn: fetchUpdateAssignmentToPass });
};
